import React from 'react'
import { Typography, Box } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const ErrorMessageComponent = ({ message }) => {
  const { t } = useTranslation()
  if (typeof message === 'object' && message.translation) {
    return (
      <Box paddingX={2}>
        <Typography variant="body2" color="error">
          {t(message.translation, message.data)}
        </Typography>
      </Box>
    )
  }
  return (
    <Box paddingX={2}>
      {typeof message === 'string' && (
        <Typography variant="body2" color="error">
          {message}
        </Typography>
      )}
    </Box>
  )
}

export default ErrorMessageComponent
